import { render, staticRenderFns } from "./EduClassStudent.vue?vue&type=template&id=1c5c7b93&scoped=true"
import script from "./EduClassStudent.vue?vue&type=script&lang=js"
export * from "./EduClassStudent.vue?vue&type=script&lang=js"
import style0 from "./EduClassStudent.vue?vue&type=style&index=0&id=1c5c7b93&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c7b93",
  null
  
)

export default component.exports